// Services
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js";

// Constants
import { STATUS_CODES, USER_STATUS } from "@/app/constants/status-constants";

// Components
const ClientHeader = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "client-header" */ "@/app/views/client-view/_shared/client-header/client-header.vue"
    );
const TheFooter = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "the-footer" */ "@/app/views/main-view/_shared/the-footer/the-footer.vue"
    );

// Mixins
import { googleTagManagerMixins } from "@/app/mixins/utils/google-tag-manager-mixins";
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
    name: "ActivationEmailPage",
    components: {
        ClientHeader,
        TheFooter,
    },
    directive: {},
    filters: {},
    mixins: [
        googleTagManagerMixins,
        toastMessageMixins,
    ],
    props: {},
    data() {
        return {
            hasLatitudePay: false,
            showMainLogo: true,
            isUserPending: false,
            isUserActive: false,
            isAPILoading: false,
            dogImg: require(`@/assets/images/_shared/notification-dog.png`),
        };
    },
    computed: {
        isNativeApp() {
            return this.$store.getters.getIsNativeApp;
        },
    },
    watch: {},
    async created() {
        await this.processUserActivationAndPuppyDetails(this.$route.query.referenceId);
    },
    methods: {
        async processUserActivationAndPuppyDetails(referenceNumber) {
            this.isAPILoading = true;
            try {
                const response =
                    await puppySellService.processUserActivationAndPuppyDetails(
                        referenceNumber
                    );

                if (response.status === STATUS_CODES.SUCCESS) {
                    const userDetails = response.data[0];

                    const { status } = userDetails;

                    if(status === USER_STATUS.PENDING){
                        // if the status is PENDING "P", that means an activation email has already been sent
                        this.isUserPending = true;
                    }
                    else if(status === USER_STATUS.WAITING){
                        this.isUserPending = false;
                    }
                    else if(status === USER_STATUS.ACTIVE){
                        this.isUserActive = true;
                        this.isUserPending = false;

                        this.dogImg = require(`@/assets/images/_shared/success-dog.png`);
                    }
                } else {
                    this.showAPIErrorToast("Unable to process user details.", response);
                }

                this.isAPILoading = false;
            } catch (err) {
                this.showGenericErrorToast();
                this.isAPILoading = false;
            }
        },
    },
};
